export const FETCHING_LETTERS = '@@toyota/FETCHING_LETTERS';
export const FETCHED_LETTERS = '@@toyota/FETCHED_LETTERS';
export const FETCHED_LETTERS_FAILED = '@@toyota/FETCHED_LETTERS_FAILED';

export const FETCHING_ICC_STOCK = '@@toyota/FETCHING_ICC_STOCK';
export const FETCHED_ICC_STOCK = '@@toyota/FETCHED_ICC_STOCK';
export const FETCHED_ICC_STOCK_FAILED = '@@toyota/FETCHED_ICC_STOCK_FAILED';

export const FETCHING_ICC_SALES = '@@toyota/FETCHING_ICC_SALES';
export const FETCHED_ICC_SALES = '@@toyota/FETCHED_ICC_SALES';
export const FETCHED_ICC_SALES_FAILED = '@@toyota/FETCHED_ICC_SALES_FAILED';
